import { FC, useEffect, useState } from "react";

import { observer } from "mobx-react";

import { TABLE_ABLE } from "../constants/Features";
import { parsingOCRStore } from "../utils/mobx/ParsingOCRStore";
import { parsingTableStore } from "../utils/mobx/ParsingTableStore";
import { resultInteractionStore } from "../utils/mobx/ResultInteractionStore";
import { cn } from "../utils/style";

interface ParsingResultOCRProps {
  disabled?: boolean;
}

const ParsingResultOCR: FC<ParsingResultOCRProps> = ({ disabled = false }) => {
  const {
    setAdditionalFocusIndexes,
    additionalFocusIndexes,
    hoveredBoxIds,
    setHoveredBoxIds,
    selectedBoxIds,
    setSelectedBoxIds,
    focusIndex: curIndex,
    setFocusIndex: setIndex,
    setFocusEnable,
  } = resultInteractionStore;
  const { confidenceThreshold } = parsingTableStore;
  const { ocrLines: lineGroups, values, orgLargestId } = parsingOCRStore;
  const [isRowClicked, setIsRowClicked] = useState(false);

  const [hoverIndex, setHoverIndex] = useState<number>(-1);

  useEffect(() => {
    // 이미지뷰에서 박스가 클릭되었을때만 자동 스크롤
    if (isRowClicked) {
      setIsRowClicked(false);
      return;
    }

    if (selectedBoxIds.length) {
      const boxId = selectedBoxIds[0];
      document.getElementById(`row-${boxId}`)?.scrollIntoView({
        behavior: "smooth" as ScrollBehavior,
        block: "center" as ScrollLogicalPosition,
      });
      lineGroups.forEach((lineGroup, idx) => {
        if (
          selectedBoxIds.includes(`page-${lineGroup.page}-line-${lineGroup.id}`)
        ) {
          setIndex(idx);
          return;
        }
      });
    }
  }, [selectedBoxIds]);

  return (
    <>
      <div>
        {lineGroups.length > 0 && (
          <div className="body flex min-w-full flex-col items-end overflow-auto rounded-lg bg-background p-4">
            <table className="flex w-full border-collapse flex-col">
              <tbody className="flex w-full flex-col items-start justify-start rounded">
                {lineGroups.map((lineGroup, idx) => {
                  const linecontent = values[idx];
                  const isSelected =
                    curIndex === idx ||
                    (curIndex === -1 &&
                      selectedBoxIds.includes(
                        `page-${lineGroup.page}-line-${lineGroup.id}`,
                      ));
                  const isHovered =
                    hoverIndex === idx ||
                    (hoverIndex === -1 &&
                      hoveredBoxIds.includes(
                        `page-${lineGroup.page}-line-${lineGroup.id}`,
                      ));

                  return lineGroup ? (
                    <tr
                      className={cn({
                        "m-0.5 w-full break-words rounded text-left text-black text-opacity-90":
                          true,
                        "bg-accent-blue-background/50":
                          !disabled && (isHovered || isSelected),
                        "outline outline-1 outline-accent-blue": isSelected,
                      })}
                      id={`row-page-${lineGroup.page}-line-${lineGroup.id}`}
                      key={`idx:${idx}`}
                      onMouseEnter={() => {
                        setHoveredBoxIds([
                          `page-${lineGroup.page}-line-${lineGroup.id}`,
                        ]);
                        setHoverIndex(idx);
                      }}
                      onMouseLeave={() => {
                        setHoveredBoxIds([]);
                        setHoverIndex(-1);
                      }}
                      onClick={e => {
                        e.stopPropagation();
                        setIsRowClicked(true);
                        if (lineGroup.id < 0 || lineGroup.id > orgLargestId) {
                          setFocusEnable(false);
                        } else {
                          setFocusEnable(true);
                        }
                        if (curIndex !== -1 && (e.ctrlKey || e.metaKey)) {
                          if (additionalFocusIndexes.length === 0) {
                            (
                              document.activeElement as
                                | HTMLInputElement
                                | HTMLTextAreaElement
                            ).blur();
                          }
                        } else {
                          // 박스가 있을때만
                          if (lineGroup.boundingBox) {
                            setSelectedBoxIds([
                              `page-${lineGroup.page}-line-${lineGroup.id}`,
                            ]);
                          } else {
                            setSelectedBoxIds([]);
                          }
                          setIndex(idx);
                          setHoveredBoxIds([]);
                          setHoverIndex(-1);
                          setAdditionalFocusIndexes([]);
                        }
                      }}
                    >
                      <td
                        className={cn({
                          "flex w-full whitespace-normal p-2": true,
                          "shadow-inline":
                            idx === curIndex ||
                            additionalFocusIndexes.includes(idx),
                          "text-accent-red":
                            lineGroup.confidence != null &&
                            lineGroup.confidence < confidenceThreshold,
                        })}
                        id={`td-${idx}`}
                      >
                        <div
                          className={cn({
                            "flex items-center whitespace-pre-line px-1 focus:outline-none":
                              true,
                            "resize-none": true,
                            "bg-transparent": true,
                            "whitespace-normal": true,
                            "pointer-events-none": !TABLE_ABLE,
                          })}
                          id={"div-" + idx}
                        >
                          {" "}
                          {linecontent}
                        </div>
                      </td>
                    </tr>
                  ) : null;
                })}
              </tbody>
            </table>
          </div>
        )}
      </div>
    </>
  );
};

export default observer(ParsingResultOCR);
